angular
	.module 'App.Repository'
	.factory 'SubscriberRepository', ['BaseRepository', (BaseRepository) ->
		class SubscriberRepository extends BaseRepository
			@resource = '/subscribers'
			@isRestricted = true

		return new SubscriberRepository
	]
